import {ComponentData} from "../../engine/tools/EntityManager";
import {Vector2} from "../../engine/utils/Vector2";
import {SoundInstance} from "../../engine/tools/AudioLoader";

export class AudioSource implements ComponentData {
    instance: SoundInstance
    soundId: string

    constructor(options?: Partial<AudioSource>) {
        Object.assign(this, options)
    }
}
